import { useMemo, useState } from "react";

import {
  Button,
  ChevronDownSVG,
  ChevronUpSVG,
  Icon,
  type SvgComponentType,
} from "@newsela/angelou";

import { getAdminButtonCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenu.styles";
import { AdminMenuPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/ResourceMenus/AdminMenu/AdminMenuPopout";
import { NavButtonWithPopout } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout";
import {
  getNavMenuButtonAriaProps,
  IButtonAriaProps,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/NavButtonWithPopout/NavButtonWithPopout.utils";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { NavButtonWithPopoutText } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NavButtonWithPopoutText";

const MENU_ID = "nav-admin-menu";

const AdminMenu = () => {
  const { data: user } = useUser();
  const { isStaff, canViewAdminConsole } = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });

  const [isOpen, setIsOpen] = useState(false);

  const buttonAriaProps: IButtonAriaProps = useMemo(
    () =>
      getNavMenuButtonAriaProps({
        isOpen,
        id: MENU_ID,
      }),
    [isOpen],
  );

  if (!canViewAdminConsole && !isStaff) return null;

  const onClickButton = () => setIsOpen((isOpen) => !isOpen);

  return (
    <NavButtonWithPopout
      id={MENU_ID}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      position={{ top: "4rem", right: 8 }}
      rootCustomCss={{ display: "flex" }}
      ButtonComponent={
        <Button
          onClick={onClickButton}
          flavor={Button.flavors.incognito}
          dataProps={{ "data-qa-selector": "global-nav-admin-menu" }}
          ariaProps={buttonAriaProps}
          __cssFor={getAdminButtonCss(isOpen)}
          __classNameFor={{ root: MENU_ID }}
        >
          <NavButtonWithPopoutText>Admin</NavButtonWithPopoutText>
          {isOpen ? (
            <Icon SvgComponent={ChevronUpSVG as SvgComponentType} />
          ) : (
            <Icon SvgComponent={ChevronDownSVG as SvgComponentType} />
          )}
        </Button>
      }
      PopoutComponent={<AdminMenuPopout />}
    />
  );
};

AdminMenu.displayName = "AdminMenu";
export { AdminMenu };
